import { duration } from 'util/dateTime';

export const getCountDownValue = time => {
  const currentTime = duration(time);

  const minutes = currentTime.minutes();
  const seconds = currentTime
    .seconds()
    .toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false });

  return `${minutes}:${seconds}`;
};
